// 退换货单-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :processId="processId" :_dataId.sync="dataId"
          :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="addButton" status="primary" class="button-sty" icon="el-icon-plus"
                    @click="openEditDialog(0, 'edit')">新增
                  </vxe-button>
                  <vxe-button v-if="wkExchangeOrderExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                  <vxe-button v-if="createBatch" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="batchCreateBatch">一键生成结算单
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">

                  <vxe-form-item title="退换货单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.exchangeOrderNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.billNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot >
<!--                      <el-input v-model="formData.siteName" size="small" style="width:9vw ;" clearable />-->
                      <site-search :site-id.sync="formData.siteId" style="width:9vw ;" :show="!isSite"/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="用户电话:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.userMobile" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.createTime" type="daterange" align="right"
                        unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="是否直发:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.isDirectExchange" clearable  style="width:9vw!important ;">
                        <el-option :value="1" label="是"></el-option>
                        <el-option :value="0" label="否"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="产品条码(批量):" field="name">
                    <template v-slot>
                      <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3, maxHeight: '100px' }"  v-model="formData.barcodeBatch"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="地区:" field="name">
                    <template>
                      <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" style="width:100%;"
                        @change="handleChange" ref="cascader" :options="areaOption">
                      </el-cascader>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>


            <template #option="{ row }">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                <el-tooltip  effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="提交" v-if="row.stat == 1 && submitButton">提交</el-dropdown-item>
                  <el-dropdown-item command="取消" v-if="row.stat == 1 && cancleButton">取消</el-dropdown-item>
                  <el-dropdown-item command="一键生成安装单" v-if="!isSite && !row.installOrderId && row.stat<98 && addInstallOrderButton">一键生成安装单</el-dropdown-item>
                  <el-dropdown-item command="一键生成拆机单" v-if="!isSite && !row.dismantleOrderId && row.stat<98 && addDismantleOrderButton">一键生成拆机单</el-dropdown-item>
                  <el-dropdown-item command="可换机型" v-if="!isSite &&  row.checkStat == 10 && row.stat == 2 && canChangeModelButton">可换机型</el-dropdown-item>
                  <el-dropdown-item command="可换机型驳回" v-if="!isSite &&  row.checkStat == 10 && row.stat == 2 && canChangeModelRejectButton">驳回</el-dropdown-item>
                  <el-dropdown-item command="创建销售发货订单" v-if="!isSite &&  row.checkStat == 20 && row.stat == 2 && createSaleDeliveryOrderButton">创建销售发货订单</el-dropdown-item>
                  <el-dropdown-item command="创建销售发货订单驳回" v-if="!isSite &&  row.checkStat == 20 && row.stat == 2 && createSaleDeliveryOrderRejectButton">驳回</el-dropdown-item>
                  <el-dropdown-item command="总部服务支持经理审批" v-if="!isSite &&  row.checkStat == 30 && row.stat == 2 && headOfficeServiceSupportManagerApprovalButton">总部服务支持经理审批</el-dropdown-item>
                  <el-dropdown-item command="新件收货" v-if="isSite &&  row.checkStat == 40 && row.stat == 2 && newItemReceiptButton">新件收货</el-dropdown-item>
                  <el-dropdown-item command="旧件返厂" v-if="isSite && row.checkStat == 50 && row.stat == 2 && (!row.returnFactoryType || row.returnFactoryType == 1) && oldItemReturnFactoryButton">旧件返厂</el-dropdown-item>
                  <el-dropdown-item command="旧机回收" v-if="isSite &&  row.checkStat == 50 && row.stat == 2 && (!row.returnFactoryType || row.returnFactoryType == 2) && oldItemRecoveryButton">旧机回收</el-dropdown-item>
                  <el-dropdown-item command="总部旧件签收" v-if="!isSite &&  row.checkStat == 60 && row.stat == 2 && headOfficeOldItemSignButton">旧件签收</el-dropdown-item>
                  <el-dropdown-item command="总部旧件退回" v-if="!isSite &&  row.checkStat == 70 && row.stat == 2 && headOfficeOldItemReturnButton">旧件退回</el-dropdown-item>
                  <el-dropdown-item command="服务商旧机签收" v-if="isSite &&  row.checkStat == 80 && row.stat == 2 && serviceProviderOldItemSignButton">旧机签收</el-dropdown-item>
                  <el-dropdown-item command="品质鉴定" v-if="!isSite &&  row.checkStat == 100 && row.stat == 2 && qualityIdentificationButton">品质鉴定</el-dropdown-item>
                  <el-dropdown-item command="确认折算方式" v-if="isSite &&  row.checkStat == 110 && row.stat == 2 && confirmExchangeWayButton">确认折算方式</el-dropdown-item>
                  <el-dropdown-item command="总部输出折算方案" v-if="!isSite &&  row.checkStat == 120 && row.stat == 2 && headOfficeOutputExchangeSchemeButton">总部输出折算方案</el-dropdown-item>
                  <el-dropdown-item command="确认折算方案" v-if="isSite &&  row.checkStat == 130 && row.stat == 2 && confirmExchangeSchemeButton">确认折算方案</el-dropdown-item>
                  <el-dropdown-item command="是否挽留" v-if="!isSite && row.stat<98 && isRetainButton">是否挽留</el-dropdown-item>
                  <el-dropdown-item command="结束" v-if="!isSite && endButton && row.stat<98 ">关闭</el-dropdown-item>
                  <el-dropdown-item command="一键生成结算单" v-if="!isSite && row.stat==5 && createBatch">一键生成结算单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

<chooseItemDialog v-if="showChooseItemDialog" @commit="chooseItems"
                  :visiable.sync="showChooseItemDialog" :chooseItemParams="chooseItemParams"></chooseItemDialog>

    <commentDraw v-if="showCommentDraw" @closeDraw="closeDraw"
                      :visiable.sync="showCommentDraw" :rejectType="rejectType"
                      :commentDrawTitle="commentDrawTitle" :exchangeOrderId="exchangeOrderId"></commentDraw>
    <oldItemRecoveryDialog v-if="showOldItemRecoveryDialog" @closeDialog="closeDialog"
                 :visiable.sync="showOldItemRecoveryDialog" :exchangeOrderNo ="exchangeOrderNo"
                  :exchangeOrderId="exchangeOrderId"></oldItemRecoveryDialog>
    <oldItemReturnDialog v-if="showOldItemReturnDialog" @closeDialog="closeDialog"
                 :visiable.sync="showOldItemReturnDialog" :exchangeOrderNo ="exchangeOrderNo" :obj="exchangeOrderObj"
                 :exchangeOrderId="exchangeOrderId"></oldItemReturnDialog>
    <zbOldItemReturnDialog v-if="showZbOldItemReturnDialog" @closeDialog="closeDialog"
                         :visiable.sync="showZbOldItemReturnDialog" :exchangeOrderNo ="exchangeOrderNo"
                         :exchangeOrderId="exchangeOrderId"></zbOldItemReturnDialog>
    <quantityCheckDialog v-if="showQuantityCheckDialog" @closeDialog="closeDialog"
                           :visiable.sync="showQuantityCheckDialog" :exchangeOrderNo ="exchangeOrderNo"
                           :exchangeOrderId="exchangeOrderId"></quantityCheckDialog>

    <schemeEntryDialog v-if="showSchemeEntryDialog" @closeDialog="closeDialog"
                         :visiable.sync="showSchemeEntryDialog" :exchangeOrderNo ="exchangeOrderNo"
                         :exchangeOrderId="exchangeOrderId"></schemeEntryDialog>
    <isWlDialog v-if="showIsWl" @closeDialog="closeDialog"
                         :visiable.sync="showIsWl" :exchangeOrderNo ="exchangeOrderNo"
                         :exchangeOrderId="exchangeOrderId"></isWlDialog>
  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { dictType, loadDictData } from "@/config/dictType";
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import {siteMixins} from "@/mixins/tabChang";
import ExcelUpload from "@/components/upload/excel";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import chooseItemDialog from './chooseItemDialog.vue'
import commentDraw from './commentOperationDialog.vue'
import oldItemReturnDialog from './oldItemReturnDialog.vue'
import oldItemRecoveryDialog from './oldItemRecoveryDialog.vue'
import zbOldItemReturnDialog from './zbOldItemReturnDialog.vue'
import quantityCheckDialog from './qualityCheck.vue'
import schemeEntryDialog from './schemeEntry.vue'
import isWlDialog from './isWlDialog.vue'
// 假数据
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'
export default {
  name: 'apply',

  mixins: [siteMixins],
  inject: ['reload'],
  components: { editView, pager,ExcelUpload,SiteSearch,chooseItemDialog,commentDraw,oldItemReturnDialog,oldItemRecoveryDialog,
    zbOldItemReturnDialog,quantityCheckDialog,schemeEntryDialog,isWlDialog },
  data() {
    return {
      rejectType:null,
      commentDrawTitle:null,
      exchangeOrderId:null,
      exchangeOrderObj:{},
      showIsWl:false,
      showCommentDraw:false,
      showOldItemReturnDialog:false,
      showOldItemRecoveryDialog:false,
      showZbOldItemReturnDialog:false,
      showQuantityCheckDialog:false,
      showSchemeEntryDialog:false,
      exchangeOrderNo:null,
      chooseItemParams:{},
      showChooseItemDialog:false,
      isSite:false,
      importBackLogisticsNo: false,
      addButton:  false,
      editButton:  false,
      wkExchangeOrderExport:false,
      //提交
      submitButton: false,
      //取消
      cancleButton: false,
      //一键生成安装单
    addInstallOrderButton: false,
    //一键生成拆机单
    addDismantleOrderButton: false,
    //可换机型
    canChangeModelButton: false,
    //可换机型驳回
    canChangeModelRejectButton: false,
    //创建销售发货订单
    createSaleDeliveryOrderButton: false,
    //创建销售发货订单驳回
    createSaleDeliveryOrderRejectButton: false,
    //总部服务支持经理审批
    headOfficeServiceSupportManagerApprovalButton: false,
    //新件收货
    newItemReceiptButton: false,
    //旧件返厂
    oldItemReturnFactoryButton: false,
    //旧机回收
    oldItemRecoveryButton: false,
    //总部旧件签收
    headOfficeOldItemSignButton: false,
    //总部旧件退回
    headOfficeOldItemReturnButton: false,
    //服务商旧机签收
    serviceProviderOldItemSignButton: false,
    //品质鉴定
    qualityIdentificationButton: false,
    //确认折算方式
    confirmExchangeWayButton: false,
    //总部输出折算方案
    headOfficeOutputExchangeSchemeButton: false,
    //确认折算方案
    confirmExchangeSchemeButton: false,
    //是否挽留
    isRetainButton: false,
    //一键生成结算单
    createBatch: false,
    //结束
    endButton: false,
      first: true,

      areaOption: [],
      areaValues: [],

      orderId:null,
      showApplyPrintDialog: false,
      showPicDialog: false,
      dialogVisible: false,
      statName: '',
      dialogMsg: '',

      actPicUrl: "",

      exchangeTypeList: [],

      total: 0,
      editViewType: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        exchangeOrderNo:null,
        billNo:null,
        sourceType: null,
        siteName: null,
        userMobile: null,
        sourceNo: null,
        exchangeType: null,
        isDirectExchange: null,
        barcode: null,
        flowStatStr: null,

        areaIdPath: null,

        stat: null,
        orgId: null,
        siteId: null,
        applyType: null,
        // createDateBegin: null,
        // createDateEnd: null,
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        createTimeBegin: null,
        createTimeEnd: null,

        fuzzySearchIsEnable: true,
        fuzzySearchValue: null,

        exchangeNoBatch: null,
        barcodeBatch: null,
        checkStat:null,
      },

      formData: {
        exchangeOrderNo:null,
        billNo:null,
        barcodeBatch: null,
        exchangeNoBatch: null,
        sourceType: null,
        siteName: null,
        userMobile: null,
        sourceNo: null,
        exchangeType: null,
        isDirectExchange: null,
        barcode: null,
        flowStatStr: null,

        areaIdPath: null,

        stat: null,
        orgId: null,
        siteId: null,
        applyType: null,
        createTime: null,
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        checkDate: null,
        fuzzySearchValue: null,
        checkStat:null,
      },

      sitePromptList: [],

      goodsStatusList: [ //循环列表

      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '退换单号', field: 'exchangeOrderNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span style="color: blue"
                  onClick={($event) => this.showInfo(row, $event)}>{row.exchangeOrderNo}</span>
              ]
            }
          }
        },
        { title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral" >
                    <span>审核中</span>
                  </div>
                ];
              }else if (row.stat == 5) {
                return [
                  <div class="txt-status ">
                    <span>已审核</span>
                  </div>
                ];
              }else if (row.stat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              }else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }else if (row.stat == 98) {
                return [
                  <div class="txt-status disable">
                    <span>关闭</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '申请单号', field: 'billNo', width: 80,
        },
        {
          title: '是否直发机', field: 'isDirectExchange', width: 100, slots: {
            default: ({ row }) => {
              if (row.isDirectExchange == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isDirectExchange == 1) {
                return [
                  <div class="txt-status ">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '审核节点', field: 'checkStat', width: 80, slots: {
    default: ({ row }) => {
         if (row.checkStat == 1) {
          return [
            <div class="txt-status ">
              <span>制单</span>
            </div>
          ];
        }else if (row.checkStat == 10) {
           return [
             <div class="txt-status ">
               <span>可换机型</span>
             </div>
           ];
         }else if (row.checkStat == 20) {
           return [
             <div class="txt-status ">
               <span>创建销售发货订单</span>
             </div>
           ];
         }else if (row.checkStat == 30) {
           return [
             <div class="txt-status ">
               <span>服务支持经理审核</span>
             </div>
           ];
         }else if (row.checkStat == 40) {
           return [
             <div class="txt-status ">
               <span>新件收货</span>
             </div>
           ];
         }else if (row.checkStat == 50) {
           return [
             <div class="txt-status ">
               <span>旧机寄出</span>
             </div>
           ];
         }else if (row.checkStat == 60) {
           return [
             <div class="txt-status ">
               <span>旧机签收-总部</span>
             </div>
           ];
         }else if (row.checkStat == 70) {
           return [
             <div class="txt-status ">
               <span>旧机退回</span>
             </div>
           ];
         }else if (row.checkStat == 80) {
           return [
             <div class="txt-status ">
               <span>旧机签收-服务商</span>
             </div>
           ];
         }else if (row.checkStat == 110) {
           return [
             <div class="txt-status ">
               <span>确认折算方式</span>
             </div>
           ];
         }else if (row.checkStat == 100) {
           return [
             <div class="txt-status ">
               <span>品质鉴定</span>
             </div>
           ];
         }else if (row.checkStat == 120) {
           return [
             <div class="txt-status ">
               <span>输出折算方案</span>
             </div>
           ];
         }else if (row.checkStat == 130) {
           return [
             <div class="txt-status ">
               <span>确认折算方案</span>
             </div>
           ];
         }else if (row.checkStat == 140) {
           return [
             <div class="txt-status ">
               <span>完结</span>
             </div>
           ];
         }else if (row.checkStat == 150) {
           return [
             <div class="txt-status ">
               <span>结束</span>
             </div>
           ];
         }

      }
    }
        },

        { title: '服务机构', field: 'orgName', width: 100, },
        { title: '服务商', field: 'siteName', width: 100, },
        { title: '用户姓名', field: 'userName', width: 100, },


        {
          title: '地址(省 市 区)', field: 'area', width: 235, slots: {
            default: ({ row }) => {
              return [<span>{row.userProvince}{row.userCity}{row.userCounty}</span>]
            }
          }
        },
        { title: '产品大类', field: 'bigCategoryName', width: 80, },
        { title: '产品条码', field: 'barcode', width: 150, },

        { title: '产品名称', field: 'itemName', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },

  },
  created() {
    this.endButton = this.permissions["wkExchangeOrderEnd"];
    this.addButton = this.permissions["wkExchangeOrderAdd"];
    this.wkExchangeOrderExport = this.permissions["wkExchangeOrderExport"];
    //提交
    this.submitButton = this.permissions["wkExchangeOrderSubmit"];
      //取消
    this.cancleButton = this.permissions["wkExchangeOrderCancle"];
      //一键生成安装单
    this.addInstallOrderButton = this.permissions["wkExchangeOrderAddInstallOrder"];
      //一键生成拆机单
    this.addDismantleOrderButton = this.permissions["wkExchangeOrderAddDismantleOrder"];
      //可换机型
    this.canChangeModelButton = this.permissions["wkExchangeOrderCanChangeModel"];
      //可换机型驳回
    this.canChangeModelRejectButton = this.permissions["wkExchangeOrderCanChangeModelReject"];
      //创建销售发货订单
    this.createSaleDeliveryOrderButton = this.permissions["wkExchangeOrderCreateSaleDeliveryOrder"];
      //创建销售发货订单驳回
    this.createSaleDeliveryOrderRejectButton = this.permissions["wkExchangeOrderCreateSaleDeliveryOrderReject"];
      //总部服务支持经理审批
    this.headOfficeServiceSupportManagerApprovalButton = this.permissions["wkExchangeOrderHeadOfficeServiceSupportManagerApprovalButton"];
      //新件收货
    this.newItemReceiptButton = this.permissions["wkExchangeOrderNewItemReceipt"];
      //旧件返厂
    this.oldItemReturnFactoryButton = this.permissions["wkExchangeOrderOldItemReturnFactoryButton"];
      //旧机回收
    this.oldItemRecoveryButton = this.permissions["wkExchangeOrderOldItemRecoveryButton"];
      //总部旧件签收
    this.headOfficeOldItemSignButton = this.permissions["wkExchangeOrderHeadOfficeOldItemSignButton"];
      //总部旧件退回
    this.headOfficeOldItemReturnButton = this.permissions["wkExchangeOrderHeadOfficeOldItemReturnButton"];
      //服务商旧机签收
    this.serviceProviderOldItemSignButton = this.permissions["wkExchangeOrderServiceProviderOldItemSignButton"];
      //品质鉴定
    this.qualityIdentificationButton = this.permissions["wkExchangeOrderQualityIdentificationButton"];
      //确认折算方式
    this.confirmExchangeWayButton = this.permissions["wkExchangeOrderConfirmExchangeWayButton"];
      //总部输出折算方案
    this.headOfficeOutputExchangeSchemeButton = this.permissions["wkExchangeOrderHeadOfficeOutputExchangeScheme"];
      //确认折算方案
    this.confirmExchangeSchemeButton = this.permissions["wkExchangeOrderConfirmExchangeSchemeButton"];
      //是否挽留
    this.isRetainButton = this.permissions["wkExchangeOrderIsRetainButton"];
      //一键生成结算单
    this.createBatch = this.permissions["wkExchangeOrderCreateBatch"]
      //结束
    this.endButton = this.permissions["wkExchangeOrderEndButton"];

    this.importBackLogisticsNo = this.permissions['importBackLogisticsNo']

    if (this.currentSiteData !== null){ //网点端
      this.isSite = true
      console.log("this.currentSiteData",this.currentSiteData)
      this.formData.siteName = this.currentSiteData.userName
      this.formData.siteId = this.currentSiteData.id
    }

  },

  mounted() {
    this.initSearchDate()
    this.loadDictData()
    this.loadTabOption()
  },

  methods: {
    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.wkExchangeOrder).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.wkExchangeOrder.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    toFilterData() {
            this.searchEvent();
     },
    closeDraw(type){
      if (type){
        this.showCommentDraw = false
        this.flushed()
      }else{
        this.showCommentDraw = false
      }
    },
    closeDialog(type){
      this.$mask.close()
      if (type){
        this.showOldItemRecoveryDialog = false
        this.showOldItemReturnDialog = false
        this.showZbOldItemReturnDialog = false
        this.showQuantityCheckDialog = false
        this.showSchemeEntryDialog = false
        this.showIsWl = false
        this.flushed()
      }else{
        this.showOldItemRecoveryDialog = false
        this.showOldItemReturnDialog = false
        this.showZbOldItemReturnDialog = false
        this.showQuantityCheckDialog = false
        this.showSchemeEntryDialog = false
        this.showIsWl = false
      }
    },
    chooseItems(type){
      this.$mask.open()
      if (type){
        this.showChooseItemDialog = false
        this.flushed()
      }else{
        this.showChooseItemDialog = false
      }
      this.$mask.close()
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("退换分类").then(res => {
        this.exchangeTypeList = []
        res.data.data.forEach(item => {
          this.exchangeTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // tab也切换为列表页
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },

    flushed() {
      this.loadTabOption()
      this.$refs['table-m1'].commitProxy('reload');
    },

    refreshChange() {
      this.initTableList()
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTime = [start, end]
      this.formData.createTimeBegin = start
      this.formData.createTimeEnd = end
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {

        this.$http({
          url: api.wkExchangeOrder.getCountUrl,
          method: 'post',
          data: this.requestParam
        }).then(res => {
          this.goodsStatusList = res.data.data
          if (this.first) {

            let index = this.goodsStatusList.length - 1;
            this.requestParam.checkStat = null
            this.formData.checkStat = this.requestParam.checkStat
            this.goodsStatusIndex = index
          }
          this.first = false
        })

    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      //审核节点状态:1制单10可换机型，20创建销售发货订单，30服务支持经理审核，40，新件收货，
      // 50旧机寄出，60总部旧机签收，70总部旧机退回，80服务商旧机签收，,100品质鉴定，110，确认折算方式120输出折算方案,130,确认折算方案
      let s = null
      if (item.name === '制单') {
        s = 1
      } else if (item.name === '可换机型') {
        s = 10
      } else if (item.name === '创建销售发货订单') {
        s = 20
      }else if (item.name === '服务支持经理审核') {
        s = 30
      }else if (item.name === '新件收货') {
        s = 40
      }else if (item.name === '旧机寄出') {
        s = 50
      }else if (item.name === '旧机签收') {
        if (this.isSite){
          s = 80
        }else{
          s = 60
        }
      }else if (item.name === '旧机退回') {
          s = 70
      }else if (item.name === '确认折算方式') {
        s = 110
      }else if (item.name === '品质鉴定') {
        s = 100
      }else if (item.name === '输出折算方案') {
        s = 120
      }else if (item.name === '确认扣减金额') {
        s = 130
      }
      // 切换标签时 需要重置分页
      this.requestParam.current= 1  // 当前页面
      this.requestParam.checkStat = s
      this.formData.checkStat = s
      this.getTableData()
    },

    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userTown = null;
          this.formData.userCounty = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        // this.formData.areaId = areaNode[0].value
        this.formData.areaIdPath = areaNode[0].path.join("/")
      } else {
        this.formData.areaId = null;
        this.formData.areaIdPath = null
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }
      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }
    },
    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 加载table数据
    getTableData() {
      try {
        let tableOption = {
          vue: this,
          tableRef: 'table-m1',
          path: api.wkExchangeOrder.getPageDataUrl,
          param: this.requestParam,
          method: 'post',
          // fakeData: {
          //   total: 0,
          //   list: [
          //     { id: 1, applyNo: 'QR2023568963578',serverTypeName:'维修',stat1:'2',stat:'1',createBy:'李先生',userMobile:'17688888888',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'2',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
          //   ]
          // },
          columns: this.columns
        };

        this.vxeOption = initVxeTable(tableOption);
        this.editViewDataUpdateFlag = false;
        this.flushed()
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      // this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions

      let formData = this.formData

      this.$objCopy(this.formData, this.requestParam)

      this.requestParam.createTimeBegin = ''
      this.requestParam.createTimeEnd = ''
      if (formData.createTime !== null && formData.createTime.length !== 0) {
        this.requestParam.createTimeBegin = formData.createTime[0]
        this.requestParam.createTimeEnd = formData.createTime[1]
      }



      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    confirm() {
      this.$mask.open()
      let url = api.wkExchangeBill.getDataUrl;
      if (this.statName == '提交') {
        url += "submit";
      } else if (this.statName == '审核') {
        url += "check";
      } else if (this.statName == '取消') {
        url += "cancel";
      } else if (this.statName == '驳回') {
        url += "reject";
      }
      this.$http({
        url: url,
        method: 'post',
        data: {
          id: this.currentRow.id,
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
      this.dialogVisible = false
      this.$mask.close()

    },

    // 操作
    handleCommand(command, row) {
      this.exchangeOrderId = row.id
      this.exchangeOrderNo = row.exchangeOrderNo
      this.currentRow = row
      this.rejectType = null
      if (command === '提交') { //提交
        this.$baseConfirm('您确定要提交吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.commitDataUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });

        })
      } else if (command === '取消') { //取消
        this.$baseConfirm('您确定要取消吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.cancelDataUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      } else if (command === '一键生成安装单') {
        var params = {}
        this.$router.push({
          path: '/workorder/orderaccess/access/index',query: { exchangeOrderId: row.id,serviceTypeName:'安装工单' }
        })
      } else if (command === '一键生成拆机单') {
        var params = {}
        this.$router.push({
          path: '/workorder/orderaccess/access/index',query: { exchangeOrderId: row.id,serviceTypeName:'退换货拆机' }
        })
      }else if(command === '可换机型'){
        this.chooseItemParams = {id:row.id,buyAmount:row.buyAmount}
        this.showChooseItemDialog = true
      }else if(command === '可换机型驳回'){
        //打开驳回页面
        this.rejectType = 1
        this.commentDrawTitle = '可换机型驳回'
        this.showCommentDraw = true
      }else if(command === '创建销售发货订单驳回'){
        //打开驳回页面
        this.rejectType = 2
        this.commentDrawTitle = '创建销售发货订单驳回'
        this.showCommentDraw = true
      }else if(command === '创建销售发货订单'){
        this.$baseConfirm('您确定要创建销售发货订单吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.commitCreateSaleOrderDataUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if(command ==='总部服务支持经理审批'){
        this.commentDrawTitle = '总部服务支持经理审批'
        this.showCommentDraw = true
      }else if(command ==='新件收货'){
        this.$baseConfirm('您确定要新件收货确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.newItemTakeUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if(command ==='旧件返厂'){
        this.showOldItemReturnDialog = true
        this.exchangeOrderObj ={siteId:row.siteId,installOrderId:row.installOrderId}

      }else if(command ==='旧机回收'){
        this.showOldItemRecoveryDialog = true
      }else if(command ==='总部旧件签收'){
        this.$baseConfirm('您确定要旧件签收确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.zbOldItemTakeUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if (command ==='总部旧件退回'){
        this.showZbOldItemReturnDialog = true
      }else if (command === '服务商旧机签收') {
        this.$baseConfirm('您确定要旧件签收确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.oldItemTakeUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if (command === '品质鉴定'){
        this.showQuantityCheckDialog = true
      }else if(command === '确认折算方式'){
        this.commentDrawTitle = '确认折算方式'
        this.showCommentDraw = true
      }else if (command === '总部输出折算方案'){
        this.showSchemeEntryDialog = true
      }else if (command ==='确认折算方案'){
        this.$baseConfirm('您确定要确认折算方案吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.sureSettleSchemeUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if(command ==='是否挽留'){
        this.showIsWl = true
      }else if(command ==='结束'){
        this.$baseConfirm('您确定要关闭吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.doEndUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            if (response.data.code == 0) {
              this.$message({
                type: response.data.type,
                message: response.data.data
              });
            } else {
              this.$message({
                type: response.data.type,
                message: response.data.content
              });
            }
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if (command ==='确认折算方案'){
        this.$baseConfirm('您确定要确认折算方案吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.sureSettleSchemeUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if(command ==='是否挽留'){
        this.showIsWl = true
      }else if(command ==='一键生成结算单'){
        this.$baseConfirm('您确定要生成结算单吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.createBatchUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            if (response.data.code == 0) {
              this.$message({
                type: response.data.type,
                message: response.data.content
              });
            } else {
              this.$message({
                type: response.data.type,
                message: response.data.content
              });
            }
            this.flushed()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }
    },

    batchCreateBatch(){
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要结算的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }

      this.$baseConfirm('您确定要生成结算单吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkExchangeOrder.createBatchUrl,
          method: 'post',
          data: {ids: orderIds},
          isLoading: true,
        }).then(response => {
          this.$mask.close()
          if (response.data.code == 0) {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
          } else {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
          }
          this.flushed()
        }).catch(() => {
          this.$message.error("操作失败！");
          this.$mask.close()
        });
      })
    },


    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },

    // 新增/修改
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId

      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },
    // 选中的按钮




    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },


    closePrint(type) {
      if (type == 1) {
        this.showApplyPrintDialog = false;
      }
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
